export const isConversationExportEnabled = (userEmail: string): boolean => {
  if (!userEmail) {
    return false;
  }

  const allowedUsersEnv = import.meta.env.VITE_CONVERSATION_EXPORT_ALLOWED_USERS;
  if (!allowedUsersEnv) {
    return false;
  }

  const allowedUsers = allowedUsersEnv.split(",").map((email: string) => email.trim().toLowerCase());

  console.log(`feat:conv-export: current user allowed?: ${allowedUsers.includes(userEmail.toLowerCase())}`);

  return allowedUsers.includes(userEmail.toLowerCase());
};
